




import {Component, Prop, Vue} from "vue-property-decorator";
import {LadingPaymentType} from "@/enums/type";

@Component({
  name: "LadingPaymentTypeLabel"
})
export default class extends Vue {
  @Prop({ required: true }) readonly paymentType!: number|undefined;
  LadingPaymentType = LadingPaymentType;
}
